export default class Lightgallery {
  // @ts-ignore
  constructor(element) {
    this.element = element;
    this.mainImage = element.querySelector('.product-media img');
    this.thumbnails = [...element.querySelectorAll('.slideshow-controls__thumbnail')];
    this.activeThumb = this.thumbnails.find(thumb => thumb.getAttribute('aria-selected') === 'true');
    this.init();
  }

  init() {
    this.initThumbs();
    this.initLightGallery();
  }

  initThumbs() {
    this.thumbnails.forEach(thumb => {
      const change = () => {
        this.activeThumb.classList.remove('active');
        this.activeThumb = thumb;
        thumb.classList.add('active');
        this.mainImage.src = thumb.dataset.highresSrc;
      };

      thumb.addEventListener('click', change);

      // @ts-ignore
      thumb.addEventListener('keydown', e => {
        if (e.keyCode === 13 || e.keyCode === 32) {
          e.preventDefault();
          change();
        }
      });
    });
  }

  initLightGallery() {
    const gallery = document.querySelector('.js-lightgallery');
    if (!gallery) {
      return;
    }

    const initializeGallery = () => {
      // @ts-ignore
      if (typeof lightGallery !== 'undefined') {
        // @ts-ignore
        lightGallery(gallery, {
          counter: false,
          download: false,
        });

        const trigger = document.querySelector('.js-lightgallery-trigger');
        if (trigger) {
          trigger.addEventListener('click', e => {
            e.preventDefault();
            // @ts-ignore
            const firstLink = gallery.querySelector('a');
            if (firstLink) {
              firstLink.click();
            }
          });
        }
      } else {
        setTimeout(initializeGallery, 100);
      }
    };

    initializeGallery();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLightgallery);
} else {
  initLightgallery();
}

function initLightgallery() {
  // @ts-ignore
  if (typeof lightGallery === 'undefined') {
    const checkInterval = setInterval(() => {
      // @ts-ignore
      if (typeof lightGallery !== 'undefined') {
        clearInterval(checkInterval);
        initializeLightgallery();
      }
    }, 100);

    setTimeout(() => {
      clearInterval(checkInterval);
    }, 5000);
  } else {
    initializeLightgallery();
  }
}

function initializeLightgallery() {
  const element = document.querySelector('.product-media-gallery__slideshow-container, media-gallery');
  if (element) {
    new Lightgallery(element);
  }
}
